import React, { useEffect } from 'react';
import { Alert } from 'cstar-react-primitives/lib/redux-form/alert/Alert';
import { Container } from 'cstar-react-primitives/lib/redux-form/layout/Container';

import errorMessages from './errorMessages';
import TranslatedPageTitle from '../header/TranslatedPageTitle';
import { reportPageLoadError } from '../utils/errorUtils';

export const NotFound = () => {
    useEffect(() => {
        
        reportPageLoadError('NotFound', '', '');
    }, []);

    return (
        <Container hasSlimPadding>
            <TranslatedPageTitle pageTitle={errorMessages.notFoundTitle} />
            <Alert
                alertType="warning"
                hasHeading={false}
                message={errorMessages.notFoundTitle}
            />
        </Container>
    );
};

export default NotFound;
